import {
  IForwardToFilters,
  IForwardToLoadingStates,
  IRecentContacts,
} from "@home-health-notify/domain";
import React, { Dispatch, SetStateAction } from "react";
import ScrollListContainer from "../../../common/ScrollListContainer";
import { ForwardToContentWrapper } from "../MessagePanel.style";
import ForwardToList from "./ForwardToList";
import ForwardToSearch from "./ForwardToSearch";

interface ForwardToContentProps {
  forwardToList: IRecentContacts[];
  isLoading: IForwardToLoadingStates;
  selectedContactsToForwardTo: IRecentContacts[];
  setSelectedContactsToForwardTo: Dispatch<SetStateAction<IRecentContacts[]>>;
  fetchRecentContacts: (
    filters: IForwardToFilters,
    paginate?: boolean,
  ) => Promise<void>;
  onSearchTextChange: (searchText: string) => void;
  onSearchClear: () => void;
  filters: IForwardToFilters;
  supportsMrnSearch?: boolean;
}

function ForwardToContent({
  forwardToList,
  isLoading,
  selectedContactsToForwardTo = [],
  setSelectedContactsToForwardTo,
  fetchRecentContacts,
  onSearchTextChange,
  onSearchClear,
  filters,
  supportsMrnSearch,
}: ForwardToContentProps) {
  const handleContactsSelected = (selectedContact: IRecentContacts) => {
    setSelectedContactsToForwardTo(
      (prevSelectedContacts: IRecentContacts[]) => {
        const contactExists = prevSelectedContacts.some(
          contact => contact.id === selectedContact.id,
        );

        if (contactExists) {
          return prevSelectedContacts.filter(
            contact => contact.id !== selectedContact.id,
          );
        } else {
          return [...prevSelectedContacts, selectedContact];
        }
      },
    );
  };

  return (
    <ForwardToContentWrapper>
      <ScrollListContainer
        dataTestId="forward-message-scrollable-container"
        isLoading={
          isLoading.isTabListLoading ||
          isLoading.isSearchLoading ||
          isLoading.isNextPageLoading
        }
        onScrollCallback={() => fetchRecentContacts(filters, true)}
        resetTrigger={filters.search}
      >
        <ForwardToSearch
          searchText={filters.search ?? ""}
          onSearchTextChange={onSearchTextChange}
          onSearchClear={onSearchClear}
          isLoading={isLoading}
          autoFocus
          supportsMrnSearch={supportsMrnSearch}
        />
        <ForwardToList
          isLoading={isLoading}
          forwardToList={forwardToList}
          selectedContactsToForwardTo={selectedContactsToForwardTo}
          handleContactSelected={handleContactsSelected}
          hasSearched={!!(filters.search ?? "").trim()}
          supportsMrnSearch={supportsMrnSearch}
        />
      </ScrollListContainer>
    </ForwardToContentWrapper>
  );
}

export { ForwardToContent };
